import React, { PropTypes } from 'react';
import classNames from 'classnames';
import Select from 'react-select';
import DisplayIf from 'shared/DisplayIf.jsx';

const VirtualEntryBowler = ({
  id,
  bowlerId,
  position,
  bowlers,
  onBowlerChange,
  showCalculatedDivisionToCaptain
}) => (
    <div className="contact-card">
      <div className="contact-card-info-wrapper">
        <div
          className={classNames(
            'contact-card-avatar',
            { 'empty': !bowlerId }
          )}
        >{position}</div>
        <div className="contact-card-info">
          <div style={{
            display: 'flex'
          }}>
            <div style={{
                    flex: 1,
                    maxWidth: '360px',
                    marginRight: '5px'
              }}>
            <label htmlFor={`bowler-${position}`}>{'Bowler'}</label>
            <Select
              name={`bowler-${position}`}
              options={bowlers.map(x => ({
                value: x.id,
                label: x.name
              }))}
              placeholder="Select..."
              value={bowlerId}
              simpleValue
              searchable
              onChange={value => onBowlerChange(id, value)}
            />
            </div>
            <DisplayIf condition={showCalculatedDivisionToCaptain}>
              <div style={{
                    flex: 1,
                    marginLeft: '20px'
              }}>
                <label htmlFor={`bowler-${position}`}>{'Division'}</label>
                <div>{!bowlers.find(b => b.id == bowlerId) ? 
                        '-' : 
                        !bowlers.find(b => b.id == bowlerId).divisionName ? 
                        'Not Assigned' : 
                        <p>{bowlers.find(b => b.id == bowlerId).divisionName}</p>}</div>
              </div>
            </DisplayIf>
          </div>
          
          <DisplayIf condition={bowlers.find(b => b.id == bowlerId) ? bowlers.find(b => b.id == bowlerId).assignedByOtherCaptain : false}>
            <span className="btn btn-danger"
              disabled
              style={{ opacity: 1, marginTop: 5, maxWidth: 560 }}>
              {'Bowler already entered into All Events by another captain'}
            </span>
          </DisplayIf>
          <DisplayIf condition={bowlers.find(b => b.id == bowlerId) ? !!bowlers.find(b => b.id == bowlerId).error : false}>
            <span className="roster-notification">
              {'This bowler is no longer on your roster, please replace with a valid bowler'}
            </span>
          </DisplayIf>
       
        </div>
      </div>
    </div>
  );

VirtualEntryBowler.propTypes = {
  id: PropTypes.string.isRequired,
  bowlerId: PropTypes.string,
  position: PropTypes.number.isRequired,
  bowlers: PropTypes.arrayOf(PropTypes.object),
  onBowlerChange: PropTypes.func,
  showCalculatedDivisionToCaptain: PropTypes.bool
};

VirtualEntryBowler.defaultProps = {
  bowlers: []
};

export default VirtualEntryBowler;



// WEBPACK FOOTER //
// ./src/features/registration/manage/VirtualEntryBowler.jsx